<template>
  <div class="most-predicted">
    <div class="most-predicted__header">
      <div>
        {{ title }}
      </div>
      <div class="most-predicted__header-arrows" v-if="isLayoutMobile">
        <span @click="prevSlide" :class="prevArrowModifiers"></span>
        <span @click="nextSlide" :class="nextArrowModifiers"></span>
      </div>
    </div>
    <div class="row most-predicted__content">
      <swiper
        v-if="isLayoutMobile"
        v-bind="swiperOptions"
        ref="swiper"
        @swiper="onSwiperReady"
        @transitionStart="onTransitionStart"
      >
        <swiper-slide v-for="item in items" :key="item.marketId">
          <market-list-item
            class="most-predicted__swiper-slide"
            :market="item"
            theme="home"
          ></market-list-item>
        </swiper-slide>
      </swiper>
      <div class="row" v-else>
        <div
          v-for="market in items"
          :key="market.marketId"
          class="large-4 column most-predicted__swiper-column"
        >
          <market-list-item :market="market" :key="market.marketId" theme="home"></market-list-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./most-predicted.js"></script>
<style src="./most-predicted.scss" lang="scss"></style>
